import { default as MuiTableBody, TableBodyProps } from '@mui/material/TableBody'
import * as React from 'react'

const TableBody: React.FC<React.PropsWithChildren<TableBodyProps>> = (props) => <MuiTableBody {...props} />

export default TableBody
